module.exports = __webpack_public_path__ + "school/img/LDxingweiyuyishu.9ebf16b3.png";